import React, { useState, useEffect } from 'react';
import { Alert, IconButton, Collapse, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API_BASE_URL } from '../config';

const SystemBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) return;

        const response = await fetch(`${API_BASE_URL}/System/announcement`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.ok) {
            const data = await response.json();
            if (data) {
                const dismissedId = localStorage.getItem('dismissedAnnouncementId');
                if (dismissedId !== data.id.toString()) {
                    setAnnouncement(data);
                }
            }
        }
      } catch (error) {
        console.error("Failed to fetch announcement", error);
      }
    };

    fetchAnnouncement();
  }, []);

  const handleClose = () => {
    setOpen(false);
    if (announcement) {
        localStorage.setItem('dismissedAnnouncementId', announcement.id.toString());
    }
  };

  if (!announcement) return null;

  return (
    <Box sx={{ width: '100%', position: 'sticky', top: 0, zIndex: 9999 }}>
      <Collapse in={open}>
        <Alert
          severity={announcement.type || 'info'}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ 
            borderRadius: 0, 
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {announcement.message}
        </Alert>
      </Collapse>
    </Box>
  );
};

export default SystemBanner;